import React from 'react';

import Link from 'common/Link';
import { cn } from 'common/style/utils';
import styles from 'css-module/components/subdomain/admin/v2/_AdminV2Nav.module.scss';

import AdminV2NavTooltip from './AdminV2NavTooltip';

import type { LucideIcon } from 'lucide-react';

type Props = {
  Icon: LucideIcon;
  label: string;
  to: string;
  active?: boolean;
};

export const iconLinkClass = cn(
  styles.iconLink,
  'border border-transparent',
  'unstyled-button hover:bg-sidebar-accent',
  'data-[active=true]:bg-sidebar-accent',
);

const AdminV2NavIconLink = ({ Icon, label, to, active = false }: Props) => {
  return (
    <Link
      aria-label={label}
      data-active={active ? true : undefined}
      className={iconLinkClass}
      to={to}>
      <Icon className={styles.icon} strokeWidth={1.5} />
      <AdminV2NavTooltip label={label} className={styles.tooltip} />
    </Link>
  );
};

export default AdminV2NavIconLink;
